import { useState, useEffect, useCallback } from 'react';
import { listClasses, ListClassesParams } from '../services/classes';
import { ClassSummary } from '../types/models';

export function useClasses(params: ListClassesParams | null) {
  const [classes, setClasses] = useState<ClassSummary[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const locationId = params?.locationId;
  const startDate = params?.startDate;
  const endDate = params?.endDate;
  const availableOnly = params?.availableOnly;
  const hasParams = params !== null;

  const fetch = useCallback(async () => {
    if (!hasParams) return;
    setLoading(true);
    setError(null);
    try {
      const data = await listClasses({ locationId, startDate, endDate, availableOnly } as ListClassesParams);
      setClasses(data);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }, [hasParams, locationId, startDate, endDate, availableOnly]);

  useEffect(() => { fetch(); }, [fetch]);

  return { classes, loading, error, refetch: fetch };
}
